import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function ProductSmsTutor() {
  usePageMeta(
    'SMS Tutor',
    'SMS Tutor (smstutor.com) is a coming-soon web platform for parents and guardians to arrange tutoring support for their students.'
  );

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <div className="product-hero-top">
            <span className="badge badge--soon">Coming soon</span>
            <span style={{ color: 'var(--text-muted)', fontWeight: 600, fontSize: '0.9rem' }}>
              For parents & guardians · Web app · smstutor.com
            </span>
          </div>
          <h1>SMS Tutor</h1>
          <p className="product-hero-lead">
            SMS Tutor is a web platform we're building for parents and
            guardians — a simple way to arrange tutoring support to help
            teach their students. It's currently in development.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              Register your interest
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'start' }}>
            <div>
              <h2>What it will do</h2>
              <p>
                SMS Tutor will give parents and guardians a straightforward
                web interface to purchase tutoring support for their
                students — designed for families rather than schools.
              </p>
              <p>
                We're still building it. If you're interested in early
                access once it launches, let us know via the contact page
                and we'll keep you posted.
              </p>
            </div>
            <div>
              <h2>Built for</h2>
              <ul className="feature-list">
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Parents and guardians looking for tutoring support for their kids</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>A simple, family-friendly web interface — no school sign-up required</span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>Purchasing support directly, on your own terms</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="callout callout--amber">
            <h3 style={{ marginBottom: 8 }}>Want to hear when SMS Tutor launches?</h3>
            <p style={{ marginBottom: 16 }}>
              Send us a message and we'll let you know as soon as
              smstutor.com is ready.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Register your interest
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductSmsTutor;
